import { useEffect, useState } from "react";
import { GetCompanyById } from "../../services/CompanyService";
import { GetNoticeById } from "../../services/NoticeService";

interface MessageProps {
  noticeId: any;
  myCompanyName: string;
  OtherCompanyId: any;
  filter: string;

  //messageTypes: number;
}

// Define the Message component
const GroupCard: React.FC<MessageProps> = ({
  noticeId,
  myCompanyName,
  OtherCompanyId,
  filter,
}) => {
  const [noticeTitle, setNoticeTitle] = useState("");
  const [otherCompany, setOtherCompany] = useState("");

  // async function GetNoticeByIdAsync(id: any) {
  //   return await GetNoticeById(id);
  // }
  async function GetCompanyByIdAsync() {
    await GetCompanyById(OtherCompanyId).then((p) =>
      setOtherCompany(p.data.data.name)
    );
  }

  useEffect(() => {
    //GetNoticeByIdAsync(noticeId).then((p) => setNoticeTitle(p.data.title));
    GetCompanyByIdAsync();
  }, []);

  useEffect(() => {
    //GetNoticeByIdAsync(noticeId).then((p) => setNoticeTitle(p.data.title));
  }, [filter]);
  if (filter !== "" && otherCompany && otherCompany.includes(filter)) {
    return <div className="card p-2 mt-1">{otherCompany}</div>;
  } else if (filter !== "" && otherCompany && !otherCompany.includes(filter)) {
    return null;
  } else if (filter === "") {
    return <div className="card p-2 mt-1">{otherCompany}</div>;
  }
};
export default GroupCard;
